import Reac, { useState } from 'react';
import supabase from '../helper/supabaseClient';
import '../index.scss';

function Register({switchToLogin}) {

const [email,setEmail ] = useState("");
const [password, setPassword] = useState("");
const [message, setMessage] = useState("");
const [error, setError] = useState("");

const handleSubmit = async (event) => {
  event.preventDefault();
  setMessage("");

  const {data, error} = await supabase.auth.signUp({
    email: email,
    password: password,
    options: {
      emailRedirectTo: 'https://portal.1664trainingsolutions.co.uk/dashboard'
    }
  });

  if (error) {
    if (error.message.includes("already registered")) {
      setError("already-registered");
      setMessage("");
    } else {
      setError(error.message);
      setMessage("");
    };
    return;
  }

if (data.user?.identities?.length === 0) {
  setError("already-registered");
  setMessage("");
  return;
}

  setEmail("");
  setPassword("");
  setError("");
  setMessage("Success! Please check your email to complete your registration.")
}


  return (
    <div>
        <h2 style={{fontSize: "1.6rem"}}>PLEASE REGISTER</h2>  
        
      <form className="register" onSubmit={handleSubmit}> 
        <input
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          type="email"
          placeholder="Email"
          required/>
        <br></br>

        <input 
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          type="password"
          placeholder="Password"
          required/>
        <br></br>

        <button type="submit">Submit</button>
      </form>
      <br></br>
      {error === "already-registered" ? (
        <p className="error-message">
          This email is already registered. Please{" "}<span className="clickable" onClick={switchToLogin}> log in instead</span>
        </p>
      ) : (error && <span>{error}</span>)}
      {message && <p className="success">{message}</p>}

      <p>Already registered? <span className="clickable" 
        onClick={switchToLogin}>Click here to login</span></p>
    </div>
  )
}

export default Register